import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import setProjectFormVisibilityControl from 'scenes/ProjectForms/utils/setProjectFormVisibilityControl';

export const saveProjectFormVisibilityControl = createAsyncThunk(
  'projectForm/saveProjectFormVisibilityControl',
  async (data) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const params = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };

    const projectFormVisibility = await setProjectFormVisibilityControl(
      data,
      params
    );

    return { projectFormVisibility };
  }
);
